import React from 'react';
import { Container, Row } from 'react-grid-system';
import { FLASH_MESSAGE_TIMEOUT, useFlashMessage } from '../../containers/FlashMessage';
import {
  DELETE_PAYMENT_PLAN_STORE_KEY,
  FORCE_DELETE_PAYMENT_PLAN_STORE_KEY,
} from '../../redux/payment-plan/payment-plan.actions';
import Button from '../Button';
import FlashMessage from '../FlashMessage';
import Modal from '../Modal';
import { Header3, P1 } from '../Typography';

interface DeletePaymentPlanModalProps {
  onDismiss: () => void;
  onSubmit: () => void;
  isSubmitting: boolean;
  isForceDelete?: boolean;
}

const DeletePaymentPlanModal: React.FC<DeletePaymentPlanModalProps> = ({
  onDismiss,
  onSubmit,
  isSubmitting,
  isForceDelete = false,
}) => {
  const flashMessageKey = isForceDelete ? FORCE_DELETE_PAYMENT_PLAN_STORE_KEY : DELETE_PAYMENT_PLAN_STORE_KEY;
  const [flashMessagePayload, dismissFlashMessage] = useFlashMessage([flashMessageKey]);
  const title = isForceDelete ? 'Force Delete Active Payment Plan' : 'Delete Payment Plan';
  const bodyText = isForceDelete
    ? 'Are you sure you would like to force delete this active payment plan? This delete is permanent and cannot be undone.'
    : 'Are you sure you would like to delete this payment plan?';

  return (
    <Modal onDismiss={onDismiss}>
      {flashMessagePayload ? (
        <FlashMessage payload={flashMessagePayload} onDismiss={dismissFlashMessage} timeRemaining={FLASH_MESSAGE_TIMEOUT} />
      ) : null}
      <Header3 style={{ marginBottom: 15 }}>{title}</Header3>
      <P1 style={{ marginBottom: 20 }}>{bodyText}</P1>
      <>
        <Container fluid>
          <Row style={{ display: 'flex', justifyContent: 'flex-end', columnGap: '8px', paddingTop: '24px' }}>
            <Button buttonType="secondary" noArrow={true} onClick={onDismiss}>
              Cancel
            </Button>
            <Button
              disabled={isSubmitting}
              onClick={onSubmit}
              buttonType={isForceDelete ? 'warning' : 'primary'}
            >
              {isForceDelete ? 'Force Delete' : 'Confirm'}
            </Button>
          </Row>
        </Container>
      </>
    </Modal>
  );
};

export default DeletePaymentPlanModal;
